import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
function findcoa(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get(`coa/findcoa/${obj.kodeacc}/${obj.tahun}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}
function list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'pasalpph', 'kodeacc', 'prepaid'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/pph${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

function save(data) {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.post("pph", data);
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

function remove(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.delete(`pph/${obj.pasalpph}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

export default {
    findcoa,list, 
    save,
    remove
};